import { type FC, useCallback } from 'react';

import type { SegmentEntityWithIdNormalized } from '@iconik-io/shared-lib/src/redux/entities/normalized/segment';

import { COMMENT_KEYFRAME_MODAL } from '../../constants/modals';
import { openModal } from '../../ducks/modals_manager/slice';
import { useAppDispatch, useAppSelector } from '../../store/react_redux_typed';
import Linkify from '../../ui/linkify/linkify';

import mixins from '../../styles/core/mixins.module.css';
import styles from './segment_value_comment.module.css';

type Props = {
  segment: SegmentEntityWithIdNormalized;
  value: string;
};

export const SegmentValueComment: FC<Props> = (props) => {
  const keyframe = useAppSelector((state) =>
    props.segment.keyframe_id
      ? state.entities.keyframes[props.segment.keyframe_id]
      : undefined,
  );

  const dispatch = useAppDispatch();

  const handleImageClick = useCallback(() => {
    if (!keyframe) {
      return;
    }
    dispatch(
      openModal({ id: COMMENT_KEYFRAME_MODAL, contextItems: [keyframe] }),
    );
  }, [keyframe]);

  return (
    <>
      <span aria-label="Comment text">
        <Linkify>{props.value}</Linkify>
      </span>
      {keyframe ? (
        <div className={styles.images}>
          <button className={mixins.reset_button} onClick={handleImageClick}>
            <img
              className={styles.image}
              src={keyframe.url}
              alt="Attached keyframe"
            />
          </button>
        </div>
      ) : null}
    </>
  );
};
